import classNames from 'classnames';
import { FC, memo } from 'react';
import { NavLink } from 'react-router-dom';
import { localeStore } from 'src/mobx/localesStore';
import { hasRole } from 'src/utils/helpers';
import './style.scss';

export interface IScreenTab {
  path: string;
  title: string;
  accessRoles?: string[];
  visible?: boolean;
  disabled?: boolean;
  className?: string;
}

interface IProps {
  options: IScreenTab[];
  showSoloOption?: boolean;
  className?: string;
}

const ScreenTabsNavigation: FC<IProps> = ({ options, showSoloOption, className }: IProps): JSX.Element => {
  const visibleOptions = options.filter((option) => {
    // check access if roles was provided
    if (option.accessRoles?.length && !hasRole(option.accessRoles)) return false;
    if ('visible' in option && option.visible === false) return false;

    return true;
  });

  // If less than two options to toggle, then render a simple indented stub.
  if (!showSoloOption && visibleOptions.length < 2) return <div className="mt-6" />;

  return (
    <div className={classNames('screen-tabs-navigation', className)}>
      {visibleOptions.map((option) => (
        <NavLink
          key={option.path}
          to={option.path}
          isActive={(match, location) => location.pathname.includes(option.path)}
          className={classNames('screen-tabs-navigation__link', { 'screen-tabs-navigation__link_disabled': option.disabled }, option.className)}
          activeClassName="screen-tabs-navigation__link_active"
        >
          <p className="screen-tabs-navigation__link-text">{localeStore.t(option.title)}</p>
        </NavLink>
      ))}
    </div>
  );
};

export default memo(ScreenTabsNavigation);
